import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    app_versions_container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%',
    },
}));

export {useStyles}
